import React, { useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { userService, USER_ID_KEY } from './services/userService';
import { UserProfile as UserProfileType, UserProgressItem } from './types/user';

function UserProfile() {
  const navigate = useNavigate();
  const [user, setUser] = useState<UserProfileType | null>(null);
  const [progress, setProgress] = useState<UserProgressItem[]>([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState<string | null>(null);

  useEffect(() => {
    const userId = localStorage.getItem(USER_ID_KEY);
    if (!userId) {
      navigate('/login');
      return;
    }

    Promise.all([userService.getUser(userId), userService.getProgress(userId)])
      .then(([userData, progressData]) => {
        setUser(userData);
        setProgress(progressData);
      })
      .catch(() => setError('Kunne ikke hente profildata.'))
      .finally(() => setLoading(false));
  }, [navigate]);

  const handleLogout = () => {
    localStorage.removeItem(USER_ID_KEY);
    navigate('/login');
  };

  if (loading) {
    return (
      <div className="App">
        <header className="App-header">
          <p>Indlæser...</p>
        </header>
      </div>
    );
  }

  if (error) {
    return (
      <div className="App">
        <header className="App-header">
          <p>{error}</p>
        </header>
      </div>
    );
  }

  return (
    <div className="App">
      <header className="App-header">
        <div className="content-container">
          <button className="close-button" onClick={() => navigate('/')}>
            &times;
          </button>

          {user && (
            <>
              <h2>{user.username}</h2>

              <div className="user-stats">
                <div className="stat-card">
                  <span className="stat-value">{user.totalXp}</span>
                  <span className="stat-label">Total XP</span>
                </div>
                <div className="stat-card">
                  <span className="stat-value">{user.hasTrainedToday ? '✔' : '✘'}</span>
                  <span className="stat-label">Trænet i dag</span>
                </div>
                {user.lastTrainingDate && (
                  <div className="stat-card">
                    <span className="stat-value">
                      {new Date(user.lastTrainingDate).toLocaleDateString('da-DK')}
                    </span>
                    <span className="stat-label">Sidste træning</span>
                  </div>
                )}
              </div>

              {progress.length > 0 ? (
                <div className="progress-section">
                  <h3>Fremskridt</h3>
                  <ul className="data-list">
                    {progress.map((p) => (
                      <li key={p.id} className="data-item progress-item">
                        <div className="mastery-bar-label">
                          <span>Niveau {p.masteryLevel}</span>
                          {p.lastPracticed && (
                            <span className="last-practiced">
                              {new Date(p.lastPracticed).toLocaleDateString('da-DK')}
                            </span>
                          )}
                        </div>
                        <div className="mastery-bar-track">
                          <div
                            className="mastery-bar-fill"
                            style={{ width: `${Math.min(p.masteryLevel * 10, 100)}%` }}
                          />
                        </div>
                      </li>
                    ))}
                  </ul>
                </div>
              ) : (
                <p style={{ marginTop: '1.5rem', opacity: 0.7 }}>
                  Ingen fremskridt registreret endnu.
                </p>
              )}

              <button
                className="quiz-link user-btn user-btn-secondary"
                style={{ marginTop: '2rem' }}
                onClick={handleLogout}
              >
                Skift bruger
              </button>
            </>
          )}
        </div>
      </header>
    </div>
  );
}

export default UserProfile;
